import { api, authHeader } from "../configs/axiosConfigs";

const BASE = "api/admin/mission-control";

const request = async (url, method = "GET") => {
  try {
    const response = await api.request({
      url,
      method,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    const res = error?.response?.data;
    if (res) return res;
    throw error;
  }
};

const normalize = (res, fallbackMessage) => {
  const isSuccess = res?.isSuccess ?? res?.IsSuccess;
  if (!res || isSuccess === false) {
    return {
      error: res?.message || res?.Message || fallbackMessage,
      data: null,
    };
  }
  return {
    error: null,
    data: res.data ?? res.Data ?? res,
  };
};

const MissionControlApi = {
  getDashboard: () => request(`${BASE}/dashboard`),
  normalize,
};

export default MissionControlApi;
